import React from "react";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { CustomTooltip } from './CustomTooltip';

// import type { ChartProps } from '../Charts.types';

export const BarsChart = ({
  data,
  dataKey,
  dataset,
  layout = 'horizontal',
  showLegend,
  label,
  size,
  tickAngle,
  domain,
}) => {
  const categoryKey = dataKey.xAxis;
  const valueKey = dataset?.[0]?.dataKey;
  const isVertical = layout === 'vertical';

  const xAxisDataKey = isVertical ? valueKey : categoryKey;
  const xAxisType = isVertical ? 'number' : 'category';

  const yAxisDataKey = isVertical ? categoryKey : undefined;
  const yAxisType = isVertical ? 'category' : 'number';

  return (
    <ResponsiveContainer width="100%" height={size?.height || 300}>
      <BarChart
        data={data}
        layout={layout}
        margin={{
          top: 5,
          right: 0,
          left: -20,
          bottom: 5,
        }}
      >
      <CartesianGrid vertical={false} />
      <XAxis
        dataKey={xAxisDataKey}
        type={xAxisType}
        domain={domain?.xAxis}
        tickLine={false}
        axisLine={false}
        angle={tickAngle?.xAxis}
        interval={1}
        tick={{ dy: 10 }}
      />
      <YAxis
        dataKey={yAxisDataKey}
        domain={domain?.yAxis}
        type={yAxisType}
        tickLine={false}
        axisLine={false}
        angle={tickAngle?.yAxis}
      />
      <Tooltip
        content={
          <CustomTooltip
            customTooltipLabel={{
              title: label?.top ? label.top : '',
              unit: label?.center ? label.center : '',
            }}
          />
        }
        cursor={false}
      />
      {showLegend == true && <Legend />}
      {(dataset || []).map((set, index) => (
        <Bar key={index} dataKey={set.dataKey} fill={set.color} radius={8} />
      ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
